import safeToLowerCase from '../../utils/safeToLowerCase';
import Language from '../lang/language';
import Translation from '../lang/Translation';
import {getBillingAddress} from '../selectors/PlaceOrderSelectors/PlaceOrderPropertiesSelectors';
import {getSettings} from '../selectors/selectors';
import {setPageMessage} from './pageMessageActions';

export default (dispatch, getState) => {
  const billingAddressDetails = getBillingAddress(getState());
  
  if (billingAddressDetails) {
    const blockBillingAddressSetting = getSettings(getState()).block_billing_address_containing;
    const billingAddressDetailsArray = Object.values(billingAddressDetails) || [];
    
    if (blockBillingAddressSetting && billingAddressDetailsArray.length > 0) {
      const [invalidAddressIdentifier] = Object.keys(blockBillingAddressSetting)
        .filter(invalidString => billingAddressDetailsArray
          .some(addressLine => safeToLowerCase(addressLine, true)
            ?.includes(safeToLowerCase(invalidString, true))));
      
      if (invalidAddressIdentifier && blockBillingAddressSetting[invalidAddressIdentifier]
        && Language.doesTranslationExist(blockBillingAddressSetting[invalidAddressIdentifier])) {
        dispatch(setPageMessage(Translation.getText(blockBillingAddressSetting[invalidAddressIdentifier])));
        return true;
      }
    }
  }
  
  return false;
};
